import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { bankAccountService } from '../api/bankAccountService';

// Fetch list of Nigerian banks from Monnify
export const useBanks = () => {
    return useQuery({
        queryKey: ['monnify-banks'],
        queryFn: bankAccountService.getBanks,
        staleTime: 1000 * 60 * 60 // cache for 1 hour — bank list rarely changes
    });
};

// Verify a NUBAN account number
export const useVerifyAccount = () => {
    return useMutation({
        mutationFn: bankAccountService.verifyAccount
    });
};

// Get all saved bank accounts for logged-in user
export const useBankAccounts = (userId) => {
    return useQuery({
        queryKey: ['bankAccounts', userId],
        queryFn: () => bankAccountService.getAccounts(userId)
    });
};

export const useAddBankAccount = (userId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => bankAccountService.addAccount({ ...data, userId }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['bankAccounts', userId] });
        }
    });
};

export const useDeleteBankAccount = (userId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => bankAccountService.deleteAccount(id, userId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['bankAccounts', userId] });
        }
    });
};

export const useSetDefaultAccount = (userId) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => bankAccountService.setDefaultAccount(id, userId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['bankAccounts', userId] });
        }
    });
};
